/** @format */

// a really nice component

import template from './gb-edit-raffle-draw-widget.html';
import './gb-edit-raffle-draw-widget.scss';

export const GbEditRaffleDrawWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditRaffleDrawWidgetComponent {
        constructor($gbItem, $gbRaffleItem, $rootScope, $translate, $ccLoading, LoadingHelper) {
            'ngInject';

            this.$gbItem = $gbItem;
            this.$gbRaffleItem = $gbRaffleItem;
            this.$rootScope = $rootScope;
            this.$translate = $translate;

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        getRaffleItems() {
            return this.$gbRaffleItem.cache.query({
                auction: this.gbApp.getAuctionUrl(),
            });
        }

        getItemById(itemId) {
            return this.$gbItem.cache.single(itemId);
        }

        showPreviewRaffleDraw() {
            let dummyDataLabel = this.$translate.instant('RAFFLE_PREVIEW_DUMMY_DATA_LABEL');

            let draw = {
                ticket_number: 999999,
                prize: 1,
                profile_name: dummyDataLabel,
            };
            this.$rootScope.$broadcast(this.gbApp.$raffleDrawPreviewEvent, draw);
        }

        onRafleItemChange() {
            const loader = this.loadingHelper.push('SAVING');

            this.gbEditTools.saveWidget().finally(() => {
                loader();
            });
        }
    },
};
